import type {
    BomCombinationRuleset,
    CombinationRule,
    PlacementCombinationRule,
    PlacementRule,
    CombinationRulesetRule,
} from '../../gql';

import { randBoolean, randNumber } from '@ngneat/falso';

import { mockMaterialSubcategory } from './mockMaterialSubcategory';
import { mockOperator } from './mockOperator';
import { mockPlacement } from './mockPlacement';
import { mockUsage } from './mockUsage';

const mockPlacementRule = (
    overwrite?: Partial<PlacementRule>
): PlacementRule => ({
    mustMatchOptionColour: randBoolean(),
    placement: mockPlacement(),
    ...overwrite,
    ['__typename']: 'PlacementRule',
});

const mockPlacementCombinationRule = (
    overwrite?: Partial<PlacementCombinationRule>
): PlacementCombinationRule => {
    const placementsAmount = randNumber({
        min: 1,
        max: 2,
    });
    return {
        isAllowedMultipleTimes: randBoolean(),
        placements: Array.from({ length: placementsAmount }, () =>
            mockPlacementRule()
        ),
        isExclusiveForUsage: randBoolean(),
        ...overwrite,
        ['__typename']: 'PlacementCombinationRule',
    };
};

const mockCombinationRule = (
    overwrite?: Partial<CombinationRule>
): CombinationRule => {
    const placementCombinationRulesAmount = randNumber({
        min: 1,
        max: 3,
    });
    return {
        operator: mockOperator(),
        placementCombinationRules: Array.from(
            { length: placementCombinationRulesAmount },
            () => mockPlacementCombinationRule()
        ),
        ...overwrite,
        ['__typename']: 'CombinationRule',
    };
};

const mockCombinationRulesetRule = (
    overwrite?: Partial<CombinationRulesetRule>
): CombinationRulesetRule => {
    const materialSubcategoriesAmount = randNumber({ min: 1, max: 3 });
    const combinationRulesAmount = randNumber({ min: 1, max: 3 });
    return {
        usage: mockUsage(),
        materialSubcategories: Array.from(
            { length: materialSubcategoriesAmount },
            () => mockMaterialSubcategory()
        ),
        combinationRules: Array.from({ length: combinationRulesAmount }, () =>
            mockCombinationRule()
        ),
        ...overwrite,
        ['__typename']: 'TemplateRule',
    };
};

const mockBomCombinationRuleset = (
    overwrite?: Partial<BomCombinationRuleset>
): BomCombinationRuleset => {
    const mustHaveAmount = randNumber({ min: 1, max: 3 });
    const canHaveAmount = randNumber({ min: 0, max: 3 });
    return {
        mustHave: Array.from({ length: mustHaveAmount }, () =>
            mockCombinationRulesetRule()
        ),
        canHave: Array.from({ length: canHaveAmount }, () =>
            mockCombinationRulesetRule()
        ),
        ...overwrite,
        ['__typename']: 'BomTemplate',
    };
};

export {
    mockBomCombinationRuleset,
    mockCombinationRulesetRule,
    mockPlacementRule,
    mockPlacementCombinationRule,
    mockCombinationRule,
};
